/* eslint-disable tailwindcss/no-custom-classname */

import { chakra, useMultiStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { CloseButton } from '../CloseButton/CloseButton';
import { ToastBody } from '../ToastBody/ToastBody';
import { ToastFooter } from '../ToastFooter/ToastFooter';
import { ToastIcon } from '../ToastIcon/ToastIcon';
import { ToastTitle } from '../ToastTitle/ToastTitle';

import type { ToastOptions } from './shared';
import { ToastStylesProvider } from './Toast.context';

interface ToastProps extends ToastOptions {
  onClose: () => void;
}

export const Toast = ({
  onClose,
  footer,
  description,
  title,
  status,
  isClosable = true,
}: ToastProps) => {
  const styles = useMultiStyleConfig('Toast', { status });
  return (
    <ToastStylesProvider value={styles}>
      <chakra.div __css={styles.container} className="toast-container">
        {isClosable && (
          <CloseButton
            size="sm"
            className="toast-close-button"
            onClick={onClose}
            __orbitStyleConfig={styles.closeButton}
          />
        )}
        <ToastIcon status={status} />
        <ToastTitle>{title}</ToastTitle>
        {description && <ToastBody>{description}</ToastBody>}
        {footer && (
          <ToastFooter>
            {typeof footer === 'function' ? footer(onClose) : footer}
          </ToastFooter>
        )}
      </chakra.div>
    </ToastStylesProvider>
  );
};
